import React,{ useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
const SpicyLevel = ({handleCheckChange}) => {
  
  return (
    <div className="From-select">
        <label className="input-label">
        辣度
            <Form.Select className="custom-select" onChange={handleCheckChange}>
            <option value="">--</option>
            <option value="不辣">不辣</option>
            <option value="小辣">小辣</option>
            <option value="中辣">中辣</option>
            <option value="大辣">大辣</option>
            </Form.Select>
        </label>
    </div>

  );
};

export default SpicyLevel;
